import useSize from '@react-hook/size'
import {useRef} from 'react'

export const useElementWidth = <T extends HTMLElement = HTMLDivElement>(): [
  React.RefObject<T>,
  number
] => {
  const ref = useRef<T>(null)
  const [width] = useSize(ref)
  return [ref, width]
}
